import { ApiConfig, handleResponse } from './config';
import type { SubscriptionStatus } from '../../types/expert';

export class SubscriptionService {
  constructor(private config: ApiConfig) {}

  private getAuthHeaders(): Record<string, string> {
    const headers = { ...this.config.headers };

    if (typeof window !== 'undefined') {
      try {
        const authStorage = JSON.parse(localStorage.getItem('auth-storage') || '{}');
        const token = authStorage.state?.token;
        if (token && token !== 'null' && token !== 'undefined' && token !== '') {
          headers.Authorization = `Bearer ${token}`;
        }
      } catch (error) {
        // Keep existing headers
      }
    }

    return headers;
  }

  async createCheckout(tier: string): Promise<{ sessionId: string; url: string }> {
    const headers = this.getAuthHeaders();
    const response = await fetch(`${this.config.baseUrl}/subscriptions/create-checkout`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ tier })
    });

    return handleResponse(response);
  }

  async getStatus(): Promise<SubscriptionStatus> {
    const headers = this.getAuthHeaders();
    const response = await fetch(`${this.config.baseUrl}/subscriptions/status`, {
      headers
    });

    return handleResponse(response);
  }

  async createPortalSession(): Promise<{ url: string }> {
    const headers = this.getAuthHeaders();
    const response = await fetch(`${this.config.baseUrl}/subscriptions/portal`, {
      method: 'POST',
      headers
    });

    return handleResponse(response);
  }

  async changeTier(newTier: string): Promise<{ message: string; tier: string }> {
    const headers = this.getAuthHeaders();
    const response = await fetch(`${this.config.baseUrl}/subscriptions/change-tier`, {
      method: 'PUT',
      headers,
      body: JSON.stringify({ newTier })
    });

    return handleResponse(response);
  }
}
